import * as React from 'react';
import { SVGProps } from 'react';

const SvgDownload = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.688 21c-.45 0-.844-.169-1.181-.506s-.506-.731-.506-1.181v-4.022h1.688v4.022h14.625v-4.022h1.688v4.022c0 .45-.169.844-.506 1.181s-.731.506-1.181.506H4.69zM12 16.697l-5.428-5.428 1.209-1.209 3.375 3.375V3.001h1.688v10.434l3.375-3.375 1.209 1.209L12 16.697z" />
  </svg>
);

export default SvgDownload;
